// ============================================================================
// THEME GLOBAL
// Ce fichier centralise les couleurs, typographies, espacements, boutons, etc.
// Pour les composants JSX (Button, IconButton, Navbar…)
// ============================================================================

const theme = {
  // ===========================
  // 🎨 Couleurs
  // ===========================
  colors: {
    text: {
      // general
      default: "#0b2735",         // h1       -> 
      body: "#3F5D6E",            // body     -> Label composant
      primary: "#164D63",         // h2       ->
      secondary: "#B8621B",       // h3       ->
      third:"#345A6B",            // h4       ->
      small: "#5C7A89",           // h5       ->
      verysmall:"#7D97A1",        // h6       ->
      green: "#1A8C74",           //          ->
      Authority: "#5f2040b6",     //          ->     
      //muted: "#25354dff",         //          ->  
      // custom
      cadetblue: "#64748b",     
      datagridColumn: "#666",
      required: "#ef4444",
      // common
      muted: "#94a3b8",
      danger: "#ef4444",
      success: "#22c55e",
      warning: "#f59e0b",
      // Corelia theme
      corelia: "#0e3f56", // ✅ utilisé dans Navbar
      caneva: "#c24c2c",
      stream: "#3b5d5e",
      minds: "#5c4b6e",
      pulse: "#6b4c4c",
      orbit: "#365a9b",
    },

    background: {
      app: "#fcfdff",
      surface: "#ffffff",
      panel: "#f1f3f6",
      muted: "#f1f3f6",
      input: "#f9fafb",
      selected: "#f3f4f6",
      sidebar: "#f3f4f6",
      header: "#ffffff",
      footer: "#f7f8fa",
      overlay: "rgba(255,255,255,0.95)",
      menulist: "#f2f4f8ff",
      hover: "#f7f9fcff",
      headtitle:"#fcfdff",
      form:   "#edf1f4", 
      Card: "#f9f9faff",

    },

    borders: {
      default: "#d6dee4",
      // focus: "#93c5fd",
      // panel: "#e2e8f0",
      panel: "#cfd8dd",
      contraste: "#d1d5db",
      menuList: "#d4deeeff",
      darkblue : "#b2c1c7ff",


    },

    states: {
      success: "#22c55e",
      danger: "#ef4444",
      hover: "#1e40af",
      disabled: "#cbd5e1",
      enabled: "#385272ff",

    },
  },

  // ===========================
  // 🔠 Polices
  // ===========================
  fonts: {
    primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    corelia: "'Almarai', sans-serif", // ✅ utilisé dans Navbar
    heading: "'Segoe UI', sans-serif",
    body: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },

  // ===========================
  // 🔠 Tailles de police
  // ===========================
  fontSizes: {
    v0: "0.75rem",
    vs: "0.8rem",   // 12px
    xs: "0.75rem",   // 12px
    sm: "0.90rem",  // 14px
    md: "1.05rem",      // 16px
    lg: "1.20rem",  // 18px
    xl: "1.35rem",   // 20px
    xxl: "1.5rem",   // 24px
    xxxl: "1.75rem",  //28px
    xxxxl: "2rem",    // 32px
  },

  // ===========================
  // 🔠 Graisses de police
  // ===========================
  fontWeights: {
    ultraLight: 100,
    light: 200,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    selected: 600, // ✅ utilisé dans certaines listes actives
    corelia: 600,  // ✅ utilisé dans Navbar
  },




  // ===========================
  // 🔳 Bordures & radius
  // ===========================
  borders: {
    radius: {
      sm: "2px",
      md: "4px",
      lg: "6px",
      xl: "8px",
      xxl: "12px",
      full: "9999px",
    },
    width: {
      thin: "1px solid #e2e8f0",
      thick: "2px solid #e2e8f0",
    },
  },

  // ===========================
  // 📏 Espacements
  // ===========================
  spacing: {
    zo: 0,
    vs: 2,
    xs: 4,
    sm: 6,
    md: 14,
    lg: 20,
    xl: 30,
    xxl: 60,
  },

  // ===========================
  // 🔘 Boutons
  // ===========================
  buttons: {
    black:    { background: "#000000", color: "#ffffff", hover: "#1e1e1e" },
    white:    { background: "#ffffff", color: "#000000", hover: "#f1f5f9" },
    grey:     { background: "#64748b", color: "#ffffff", hover: "#95a5a6" },
    blue:     { background: "#2980b9", color: "#ffffff", hover: "#3498db" },
    green:    { background: "#27ae60", color: "#ffffff", hover: "#1e8449" },
    magenta:  { background: "#d81b60", color: "#ffffff", hover: "#ad1457" },
    red:      { background: "#c24c2c", color: "#ffffff", hover: "#a33326ff" },
    disabled: { background: "#e5e7eb", color: "#94a3b8", hover: "#e5e7eb" },
  },


   // ===========================
  // 🔡 Typographie des composants
  // ===========================
  typography: {
    button: {
      fontFamily: "'Segoe UI', sans-serif",
      fontSize: "0.875rem", // ✅ taille cohérente
      fontWeight: 500,
      lineHeight: 1.2,
      letterSpacing: "0.5px",
      textTransform: "none",
    },
  },
    // ===========================
      // Formulaires
      // ===========================
  form: {
  label: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "0.80rem",
    fontWeight: 400,
    color: "#3F5D6E",
    marginBottom: 0,
  },

  field: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "0.9rem",
    fontWeight: 300,
    color: "#0b2735",

    // Padding interne
    paddingV: 2,
    paddingH: 8,

    // Bordure standardisée Corelia
    border: "1px solid #d6dee4",
    borderRadius: 3,

    // Fond champ
    background: "#ffffff",

    // Hauteur standard Corelia
    minHeight: 28,

    // Transitions
    transition: "all 0.15s ease-in-out",
  },

  // Couleur placeholder globale
  placeholder: "#7D97A1",

  // États
  hover: {
    borderColor: "#b8c6cc",
  },
  focus: {
    borderColor: "#164D63",
    boxShadow: "0 0 0 2px rgba(22,77,99,0.15)",
  },
  disabled: {
    background: "#f4f6f8",
    color: "#9aa8b0",
    borderColor: "#dfe4e8",
    cursor: "not-allowed",
  },

  // Ombres éventuelles
  shadows: {
    xs: "0 1px 3px rgba(11,39,53,0.08)",
  },
},


  // ===========================
  // 🌫️ Ombres
  // ===========================
  shadows: {
    xs: "0 1px 3px rgba(11,39,53,0.08)",
    sm: "0 1px 2px rgba(0, 0, 0, 0.05)",
    md: "0 4px 6px rgba(0, 0, 0, 0.1)",
    lg: "0 10px 15px rgba(0, 0, 0, 0.15)",
    xl: "0 20px 25px rgba(0, 0, 0, 0.2)",
  },

  // ===========================
  // ✨ Effets visuels
  // ===========================
  effects: {
    backdropBlur: "blur(6px)", // ✅ utilisé dans Navbar, modals, overlays
  },

 // ===========================
  // Formulaires - à été dupliquer !!!
  // ===========================
formToOld: {
  label: {
    fontFamily:"'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "0.9rem",   
    fontWeight: 200,
    color: "#3F5D6E",  // == body text color
    marginBottom: 0, // ✅ espacement entre label et champ
    
  },
  field: {
    fontFamily:"'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "1.0rem",   
    fontWeight: 400,
    color: "#0b2735",  // == default text color      
    paddingV: 5,           
    paddingH: 8,  
  },
},


// ===========================
  // DataGrid
  // ===========================
  DT: {
  font: {
    primary: 'Arial, sans-serif',
    heading: 'Roboto, sans-serif',
  },
  fontSize: {
    vo: '2px',
    vs: '6px',
    sm: '8px',
    md: '11px',
    lg: '12px',
  },
  fontWeight: {
    regular: 400,
    semiBold: 600,
    bold: 700,
  },
  colors: {
    background: {
      surface: '#f4f4f4',
      menulist: '#e2e2e2',
      hover: '#d3d3d3',
      transparent: 'rgba(0, 0, 0, 0)', // Transparent
    },
    text: {
      primary: '#164D63',
      body: '#3F5D6E',
      //datagridColumn: '#999999',
    },
    borders: {
      width: {
        thin: '1px',
        thick: '2px',
      },
      default: '#cccccc', // Couleur de bordure par défaut
      borderColor: 'rgba(211, 217, 225, 0.6)', // Couleur bleu-gris transparent pour les bordures
    },
  },
  spacing: {
    md: '4px',
    sm: '8px',
    md: '12px',
  },
},
// ===========================
// 🎨 Status & Tag Colors (harmonisés)
// ===========================
statusColors: {
  // -------------------------------------
  // 🔹 Task status (gestion interne)
  // -------------------------------------
  task: {
    todo:        { bg: "#e0e7ff", text: "#3730a3" , label: "#3730a3"}, // bleu pâle
    pending:     { bg: "#fef9c3", text: "#92400e" , label: "#92400e"}, // jaune doux
    inprogress:  { bg: "#dbeafe", text: "#1d4ed8" , label: "#1d4ed8"}, // bleu moyen
    done:        { bg: "#dcfce7", text: "#166534" , label: "#166534"}, // vert
    blocked:     { bg: "#fee2e2", text: "#991b1b" , label: "#991b1b"}, // rouge
  },

  // -------------------------------------
  // 🔹 Project status (vue globale)
  // -------------------------------------
  projectStatus: {
    Active:      { bg: "#22c55e", text: "#ffffff" , label: "#22c55e"}, // vert actif
    Inactive:    { bg: "#9ca3af", text: "#ffffff" , label: "#9ca3af"}, // gris neutre
    Archived:    { bg: "#6b7280", text: "#ffffff" , label: "#6b7280"}, // gris foncé
    Draft:       { bg: "#facc15", text: "#78350f" , label: "#facc15"}, // jaune pour brouillon
  },

  // -------------------------------------
  // 🔹 User role (rôle dans l’Account)
  // -------------------------------------
  userRole: {
    Owner:        { bg: "#1e3a8a", text: "#ffffff" , label: "#1e3a8a"}, // bleu foncé
    Administrator:{ bg: "#2563eb", text: "#ffffff" , label: "#2563eb"}, // bleu standard
    Member:       { bg: "#16a34a", text: "#ffffff" , label: "#16a34a"}, // vert
    Guest:        { bg: "#9ca3af", text: "#ffffff" , label: "#9ca3af"}, // gris neutre
  },

 // -------------------------------------
// 🔹 Project role (rôle dans le Projet)
// -------------------------------------
  projectRole: {
    Administrator: { bg: "#223f91ff", text: "#ffffff",label: "#223f91ff" }, // bleu profond, autorité
    Collaborator:  { bg: "#11803aff", text: "#ffffff", label: "#11803aff" }, // vert équilibré, implication
    Viewer:        { bg: "#6b7280", text: "#ffffff", label: "#6b7280" }, // gris neutre, observation
  },

  // -------------------------------------
  // 🔹 User status (état du compte)
  // -------------------------------------
  userStatus: {
    Active:       { bg: "#22c55e", text: "#ffffff" , label: "#22c55e"}, // vert
    Inactive:     { bg: "#9ca3af", text: "#ffffff" , label: "#9ca3af"}, // gris
    Suspended:    { bg: "#ef4444", text: "#ffffff" , label: "#ef4444"}, // rouge
    Invited:      { bg: "#3b82f6", text: "#ffffff" , label: "#3b82f6"}, // bleu
  },

  // -------------------------------------
  // 🔹 Invitation status (état de l'invitation)
  // -------------------------------------
  invitationStatus: {
    Pending:      { bg: "#f59e0b", text: "#ffffff" , label: "#f59e0b"}, // orange (en attente)
    Accepted:     { bg: "#16a34a", text: "#ffffff" , label: "#16a34a"}, // vert (acceptée)
    Declined:     { bg: "#dc2626", text: "#ffffff" , label: "#dc2626"}, // rouge (refusée)
    Removed:      { bg: "#6b7280", text: "#ffffff" , label: "#6b7280"}, // gris (supprimée)
  },
},

// -------------------------------------
// 🔹 Avatar color avec fonction d'attribution (getUserColor)
// -------------------------------------
Avatar: {
  colors: { 
    black:    { background: "#000000", color: "#ffffff", hover: "#1e1e1e" },
    white:    { background: "#f8f7aff6", color: "#000000", hover: "#f8f7afd2" },
    grey:     { background: "#64748b", color: "#ffffff", hover: "#95a5a6" },
    blue:     { background: "#2980b9", color: "#ffffff", hover: "#3498db" },
    green:    { background: "#27ae60", color: "#ffffff", hover: "#1e8449" },
    magenta:  { background: "#d81b60", color: "#ffffff", hover: "#ad1457" },
    red:      { background: "#c24c2c", color: "#ffffff", hover: "#a33326ff" },
    purple:   { background: "#8e44ad", color: "#ffffff", hover: "#6c3483" },
    orange:   { background: "#e67e22", color: "#ffffff", hover: "#ca6f1e" },
  },
}, // ✅ virgule obligatoire ici

// -------------------------------------
// 🔹 Panneau d'information
// -------------------------------------
InfoPanel: {
  white:  { bg: "#ffffff", title: "#0b2735", text: "#3F5D6E", strip: "#d6dee4", border: "#e3e7ea" },
  grey:   { bg: "#edf1f4", title: "#0b2735", text: "#3F5D6E", strip: "#b8c4cc", border: "#c7d0d6" },
  blue:   { bg: "#e8f2f6", title: "#164D63", text: "#1e5066", strip: "#5b7c8a", border: "#b7c6cc" },
  green:  { bg: "#e7f3ed", title: "#1A8C74", text: "#166a58", strip: "#3e8c75", border: "#b9cec4" },
  yellow: { bg: "#f9f3e3", title: "#B8621B", text: "#8a4a13", strip: "#c97a25", border: "#d8c6a6" },
  red:    { bg: "#f7e9e9", title: "#8a2b2b", text: "#6e1f1f", strip: "#a63a3a", border: "#d6b3b3" },
},

// -------------------------------------
// 🔹 Risk Categories
// -------------------------------------
riskCategory: {
  PLANNING:   { bg: "#dbeafe", text: "#1e3a8a", label: "#3b82f6", border: "#2563eb" },
  REGULATORY: { bg: "#fef3c7", text: "#92400e", label: "#f59e0b", border: "#d97706" },
  TECHNICAL:  { bg: "#f3e8ff", text: "#6b21a8", label: "#a855f7", border: "#9333ea" },
  RESOURCES:  { bg: "#fef9c3", text: "#854d0e", label: "#eab308", border: "#ca8a04" },
  FINANCIAL:  { bg: "#fee2e2", text: "#991b1b", label: "#dc2626", border: "#b91c1c" },
},

// -------------------------------------
// 🔹 Risk Status
// -------------------------------------
riskStatus: {
  OPEN:     { bg: "#dbeafe", text: "#1e40af", label: "#2563eb", border: "#1d4ed8" },
  MITIGATE: { bg: "#fef3c7", text: "#92400e", label: "#f59e0b", border: "#d97706" },
  CLOSE:    { bg: "#dcfce7", text: "#166534", label: "#16a34a", border: "#15803d" },
},


// -------------------------------------
// 🔹 Risk Criticity
// -------------------------------------
riskCriticity: {
  LOW:    { bg: "#dcfce7", text: "#166534", label: "#16a34a", border: "#15803d" },
  MEDIUM: { bg: "#fef3c7", text: "#92400e", label: "#f59e0b", border: "#d97706" },
  HIGH:   { bg: "#fee2e2", text: "#991b1b", label: "#dc2626", border: "#b91c1c" },
},


// ============================================================================
// 🔷 Ingénierie Système — Breakdown (A / P / F / L)
// ============================================================================

systemBreakdown: {
  types: {
    A: {
      label_fr: "Activité",
      label_en: "Activity",
      shape: "square",     // ■
      color: "#2D5BE3",
    },

    P: {
      label_fr: "Produit",
      label_en: "Product",
      shape: "spark",     // ●
      color: "#E67E22",
    },

    F: {
      label_fr: "Fonction",
      label_en: "Function",
      shape: "diamond",    // ◆
      color: "#27AE60",
    },

    L: {
      label_fr: "Localisation",
      label_en: "Location",
      shape: "triangle",   // ▲
      color: "#8E44AD",
    },
  },

  getType(code) {
    return this.types[code];
  },

  getColor(code) {
    return this.types[code]?.color;
  },

  getShape(code) {
    return this.types[code]?.shape;
  },

  getLabel(code, lang = "fr") {
    const t = this.types[code];
    if (!t) return "";
    return lang === "en" ? t.label_en : t.label_fr;
  },
},


// ============================================================================
// 🟩 Disciplines d’ingénierie (CIV / ARC / HYD / ELE / MEC / GEO / QUA / HSE / BIM)
// Shape UNIQUE = circle
// ============================================================================

SystemDisciplines: {
  shape: "circle",

  disciplines: {
    CIV: { label_fr: "Génie Civil",            label_en: "Civil Engineering",     color: "#164D63" },
    ARC: { label_fr: "Architecture",           label_en: "Architecture",          color: "#B8621B" },
    HYD: { label_fr: "Hydraulique",            label_en: "Hydraulic",             color: "#1A8C74" },
    ELE: { label_fr: "Électricité",            label_en: "Electrical Engineering",color: "#365A9B" },
    MEC: { label_fr: "Mécanique",              label_en: "Mechanical Engineering",color: "#64748B" },
    GEO: { label_fr: "Géotechnique",           label_en: "Geotechnical",          color: "#8E44AD" },
    QUA: { label_fr: "Qualité / Contrôle",     label_en: "Quality / QC",          color: "#22C55E" },
    HSE: { label_fr: "Sécurité / HSE",         label_en: "HSE / Safety",          color: "#DC2626" },
    BIM: { label_fr: "BIM / Ingénierie Num.",  label_en: "Digital Engineering",   color: "#2C8E9C" },
  },

  get(code) {
    return this.disciplines[code];
  },

  getColor(code) {
    return this.disciplines[code]?.color;
  },

  getLabel(code, lang = "fr") {
    const d = this.disciplines[code];
    if (!d) return "";
    return lang === "en" ? d.label_en : d.label_fr;
  },

  getShape() {
    return this.shape; // toujours "circle"
  },
},

buttons: {
  // --- Variantes principales (existantes) ---
  blue: {
    background: "#0E3F56",
    color: "#FFFFFF",
    hover: "#0B3346",
  },

  green: {
    background: "#1A8C74",
    color: "#FFFFFF",
    hover: "#14725E",
  },

  orange: {
    background: "#B8621B",
    color: "#FFFFFF",
    hover: "#9A4315",
  },

  grey: {
    background: "#E5E9EC",
    color: "#3F5D6E",
    hover: "#D8E0E5",
  },

  disabled: {
    background: "#E5E9EC",
    color: "#8AA0AA",
  },

  // --- Variantes pastel (NOUVEAU) ---
  pastelBlue: {
    background: "#E8F2F6",
    color: "#1E5066",
    hover: "#DCEBF1",
    border: "#B7C6CC",
  },

  pastelGreen: {
    background: "#E7F3ED",
    color: "#166A58",
    hover: "#DCEEE5",
    border: "#B9CEC4",
  },

  pastelYellow: {
    background: "#F9F3E3",
    color: "#8A4A13",
    hover: "#F3EACC",
    border: "#D8C6A6",
  },

  pastelOrange: {
    background: "#F8ECE5",
    color: "#9A4315",
    hover: "#F2DFD4",
    border: "#D8B7A3",
  },

  pastelGrey: {
    background: "#EDF1F4",
    color: "#3F5D6E",
    hover: "#E4EAEE",
    border: "#C7D0D6",
  },

  pastelRed: {
    background: "#F6E7E7",
    color: "#9C3D3D",
    hover: "#F0D9D9",
    border: "#D8B1B1",
  },
},

// -------------------------------------
  // 🔹 Generic Colors - Not Defined
  // -------------------------------------
Generic: {
  red: {
    dark:   { bg: "#8A2B2B", text: "#FFFFFF", border: "#6E1F1F" },
    pastel: { bg: "#F7E9E9", text: "#6E1F1F", border: "#D6B3B3" },
    strong: { bg: "#C23939", text: "#FFFFFF", border: "#9C2E2E" }
  },

  green: {
    dark:   { bg: "#1A8C74", text: "#FFFFFF", border: "#166A58" },
    pastel: { bg: "#E7F3ED", text: "#166A58", border: "#B9CEC4" },
    strong: { bg: "#29A885", text: "#FFFFFF", border: "#1C7D64" }
  },

  blue: {
    dark:   { bg: "#164D63", text: "#FFFFFF", border: "#113B4C" },
    pastel: { bg: "#E8F2F6", text: "#1E5066", border: "#B7C6CC" },
    strong: { bg: "#2E6F93", text: "#FFFFFF", border: "#215169" },
    selected: { bg: "#164D63", text: "#FFFFFF"},
  },

  yellow: {
    dark:   { bg: "#B8621B", text: "#FFFFFF", border: "#8A4A13" },
    pastel: { bg: "#F9F3E3", text: "#8A4A13", border: "#D8C6A6" },
    strong: { bg: "#D78429", text: "#FFFFFF", border: "#A9651F" }
  },

  orange: {
    dark:   { bg: "#C2551A", text: "#FFFFFF", border: "#9A4315" },
    pastel: { bg: "#F8ECE5", text: "#9A4315", border: "#D8B7A3" },
    strong: { bg: "#E36D2F", text: "#FFFFFF", border: "#B25724" }
  },

  grey: {
    dark:   { bg: "#3F5D6E", text: "#FFFFFF", border: "#2F4653" },
    pastel: { bg: "#EDF1F4", text: "#3F5D6E", border: "#C7D0D6" },
    strong: { bg: "#617A88", text: "#FFFFFF", border: "#4E616C" }
  },

  purple: {
    dark:   { bg: "#5A3E84", text: "#FFFFFF", border: "#442E63" },
    pastel: { bg: "#EFE9F7", text: "#4A2E70", border: "#C7B9E0" },
    strong: { bg: "#7A55B3", text: "#FFFFFF", border: "#5C4190" }
  },

  teal: {
    dark:   { bg: "#1F6F7A", text: "#FFFFFF", border: "#185760" },
    pastel: { bg: "#E7F3F4", text: "#1F6F7A", border: "#BDD0D1" },
    strong: { bg: "#2C8E9C", text: "#FFFFFF", border: "#216A74" }
  }

 
},
requirementTypes: {
  Technique: {
    bg: "#E7F3ED",
    text: "#166A58",
    border: "#B9CEC4",
  },
  Performance: {
    bg: "#E8F2F6",
    text: "#1E5066",
    border: "#B7C6CC",
  },
  Interface: {
    bg: "#F9F3E3",
    text: "#8A4A13",
    border: "#D8C6A6",
  },
  Fonctionnelle: {
    bg: "#EDF1F4",
    text: "#3F5D6E",
    border: "#C7D0D6",
  },
  Exploitation: {
    bg: "#F9ECE3",
    text: "#9A4315",
    border: "#E2C5B3",
  },
},

completenessLevels: {
  NON_EVALUE: {
    bg: "#EDF1F4",
    text: "#7D97A1",
    border: "#C7D0D6",
  },
  PARTIEL: {
    bg: "#F9F3E3",
    text: "#B8621B",
    border: "#D8C6A6",
  },
  COMPLET: {
    bg: "#E7F3ED",
    text: "#1A8C74",
    border: "#B9CEC4",
  },
},

requirementTypes: {
  Technique: {
    color: "#1E5066",
  },
  Performance: {
    color: "#166A58",
  },
  Interface: {
    color: "#8A4A13",
  },
  Fonctionnelle: {
    color: "#3F5D6E",
  },
  Exploitation: {
    color: "#9A4315",
  },
},


completenessLevels: {
  NON_EVALUE: {
    color: "#7D97A1",
  },
  PARTIEL: {
    color: "#B8621B",
  },
  COMPLET: {
    color: "#1A8C74",
  },
},


};

export default theme;

/**
 * 🔹 Retourne une couleur stable pour un utilisateur donné.
 * Basé sur le hash du nom/email.
 */
theme.getUserColor = (identifier) => {
  const keys = Object.keys(theme.Avatar.colors);
  const hash = Array.from(identifier)
    .reduce((acc, c) => acc + c.charCodeAt(0), 0);
  // -1 pour éviter d’utiliser "disabled" s’il existe
  const colors = keys.filter((k) => k !== "disabled");
  const colorKey = colors[hash % colors.length];
  return theme.Avatar.colors[colorKey];
};



export const getRiskPalette = (type, key) => {
  const map = {
    category: theme.riskCategory,
    status: theme.riskStatus,
    criticity: theme.riskCriticity,
  };
  return map[type]?.[key] ?? null;
};





  // Définition des styles en ligne pour chaque élément
  const headerStyle = {
    position: "relative",
    zIndex: 10, // Placer le bandeau au-dessus des autres éléments
  };

  const dropdownStyle = {
    position: "relative",
    zIndex: 20, // Placer le menu déroulant au-dessus
  };

  const subpageStyle = {
    position: "relative",
    zIndex: 5,  // Placer la subpage sous le bandeau et le menu déroulant
  };

  // return (
  //   <div style={pageRootStyle}>
  //     <div style={headerStyle}> {/* Bandeau supérieur */}
  //       {/* Contenu du bandeau */}
  //     </div>
      
  //     <div style={dropdownStyle}> {/* Menu déroulant */}
  //       {/* Contenu du menu déroulant */}
  //     </div>

  //     <div style={subpageStyle}> {/* Subpage */}
  //       {/* Contenu de la subpage */}
  //     </div>
  //   </div>
  // );
